import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_creator-center/admin/statistics/')({
  component: AdminIndex,
});

function AdminIndex() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({
      to: '/admin/statistics/task',
      replace: true,
    });
  }, [navigate]);

  return null;
}
